// Simple utility function without external dependencies
export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}